// lib
import { createBrowserHistory } from 'history'
export const history = createBrowserHistory({});

export const flattenRoute = (routeArr, pathPrefix, flatRoutes) => {
  routeArr.forEach(({ routes, path, ...routeInfo }) => {
    const pathTrim = path.replace(/^(\/)?(\S*)(\/)?$/, "$2");
    const absolutePath = pathPrefix + pathTrim;
    flatRoutes.push({
      path: absolutePath,
      ...routeInfo,
    });
    routes && flattenRoute(routes, `${absolutePath}/`, flatRoutes);
  });
};

/**
 * 解析URL query
 * e.g. ?a=1&b=test  ->  {a: '1', b: 'test'}
 * @param {*} queryStr 
 */
export const parseQuery = (queryStr) => {
  const ret = {};
  if (!queryStr) {
    return ret;
  }
  const queryArr = queryStr.slice(1).split('&');
  queryArr.forEach(q => {
    if (q.indexOf('=') > -1) {
      const kv = q.split('=');
      ret[kv[0]] = kv[1];
    } else {
      ret[q] = '';
    }
  })
  return ret;
}


// WEBPACK FOOTER //
// ./src/utils/router.js